import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Perfil } from '../../models/perfil.model';

import { environment } from '../../..//environments/environment';
import { CONFIG, HTTPOPTIONS } from '../../common/constants';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { Respuesta } from 'src/app/models/respuesta';

@Injectable({
  providedIn: 'root'
})
export class PerfilService extends BaseService<Perfil> {
  private perfilUrl = `${environment.apiBaseUrl}/perfiles`;

  constructor(public http: HttpClient) {
    super('PerfilService');
  }

  /** Inicio Implementacion de CRUD-DB */
  public findAll(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${this.perfilUrl}/?idapp=${CONFIG.IDAPP}`).pipe(
      map(res => res['perfiles']),
      tap(_ => this.log('Listar perfiles')),
      catchError(this.handleError('getPerfiles'))
    );
  }

  public add(perfil: Perfil): Observable<Respuesta> {
    return this.http.post<Respuesta>(this.perfilUrl, perfil, HTTPOPTIONS).pipe(
      tap((res: Respuesta) => this.log(`Agregar perfil`)),
      catchError(this.handleError('agregarPerfil'))
    );
  }

  public update(perfil: Perfil): Observable<Respuesta> {
    return this.http.put<Respuesta>(this.perfilUrl, perfil, HTTPOPTIONS).pipe(
      tap((u: Respuesta) => this.log(`Actualizar perfil`)),
      catchError(this.handleError('updatePerfil'))
    );
  }

  public delete(id: number): Observable<Respuesta> {
    const options = {
      headers: HTTPOPTIONS.headers,
      body: { id: id, idapp: CONFIG.IDAPP }
    };

    return this.http.delete<Respuesta>(`${this.perfilUrl}`, options).pipe(
      tap((res: Respuesta) => this.log(`deleted perfil | id=${res.id}`)),
      catchError(this.handleError('deletePerfil'))
    );
  }
  /** Fin Implementacion de CRUD-DB */

  public existingPerfil(nombre: string): Observable<any> {
    return this.http.post(`${this.perfilUrl}/existing/`, { c_nombre: nombre, c_idapp: CONFIG.IDAPP }, HTTPOPTIONS).pipe(
      tap(c => this.log(`existis perfil => ${nombre}`)),
      catchError(this.handleError('existingPerfil'))
    );
  }

  public getPerfilesPadre(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${this.perfilUrl}/perfilpadre/?idapp=${CONFIG.IDAPP}`).pipe(
      map(res => res['perfiles']),
      tap(_ => this.log('Listar perfiles padre')),
      catchError(this.handleError('getPerfilesPadre'))
    );
  }

  /*
  public getPerfiles(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${this.perfilUrl}/?idapp=${CONFIG.IDAPP}`)
      .pipe(
        map(res => res['perfiles']),
        tap(_ => this.log('Listar perfiles')),
        catchError(this.handleErrorNothing('getPerfiles', []))
      );
    }

    public add(perfil: Perfil): Observable<Respuesta>{
      return this.http.post<Respuesta>(this.perfilUrl, perfil, HTTPOPTIONS).pipe(
        tap((res: Respuesta) => this.log(`Agregar perfil`)),
        catchError(this.handleError('agregarPerfil'))
      );
    }

    public update(perfil: Perfil): Observable<Respuesta>{
      return this.http.put<Respuesta>(this.perfilUrl, perfil, HTTPOPTIONS).pipe(
        tap((u: Respuesta) => this.log(`Actualizar perfil`)),
        catchError(this.handleError('updatePerfil'))
      );
    }

    public delete(id: number): Observable<Respuesta>{
      const options = {
        headers: HTTPOPTIONS.headers,
        body: { id: id, idapp: CONFIG.IDAPP }
      };
  
      return this.http.delete<Respuesta>(`${this.perfilUrl}`, options).pipe(
        tap((res: Respuesta) => this.log(`deleted perfil | id=${res.id}`)),
        catchError(this.handleError('deletePerfil'))
      );
    }

    public existingPerfil(nombre: string): Observable<any> {
      return this.http.post(`${this.perfilUrl}/existing/`, { c_nombre: nombre, c_idapp: CONFIG.IDAPP }, HTTPOPTIONS).pipe(
        tap(c => this.log(`existis perfil => ${nombre}`)),
        catchError(this.handleError('existingPerfil'))
      );
    }

    public getPerfilesPadre(): Observable<Perfil[]> {
      return this.http.get<Perfil[]>(`${this.perfilUrl}/perfilpadre/?idapp=${CONFIG.IDAPP}`).pipe(
        map(res => res['perfiles']),
        tap(_ => this.log('Listar perfiles padre')),
        catchError(this.handleError('getPerfilesPadre'))
      );
    }

  public updatePerfil(perfil: Perfil): Observable<Respuesta> {
    return this.http.put<Respuesta>(this.perfilUrl, perfil, httpOptions)
      .pipe(
        // map(res => res['perfiles']),
        tap((u: Respuesta) => this.log(`Actualizar perfil`)),
        catchError(this.handleError('agregarPerfil'))
      );
  }
  */
}
